export default {
    NO_DATA_TEXT: "Нет данных для презентации"
};
